@if (testMode) {
  <div class="holder">
    <button (click)="set()" matButton="text">
      <mat-icon class="positive">swipe</mat-icon>
    </button>
  </div>
}
